var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import produce from 'immer';
import React, { useReducer } from 'react';
import { removeItemAtIndex } from '../../Shared/ArrayUtils';
import { deepGetFirstNumberOrString } from '../../Shared/ObjectUtilities';
export var MetaFormContext = React.createContext({
    updateCount: 0,
    registeredForms: [],
    formErrors: [],
    formSubmitting: false,
    formDirty: false,
    formInvalid: false,
    formFailedToSave: false,
    validateAllForms: function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.resolve([])];
            });
        });
    },
    submitAllForms: function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.resolve()];
            });
        });
    },
    registerForm: function () {
        return;
    },
    removeForm: function () {
        return;
    },
    updateForm: function () {
        return;
    }
});
var metaFormReducer = produce(function (state, action) {
    switch (action.type) {
        case 'Register_Form':
            var newFormIndex = state.registeredForms.findIndex(function (it) { return it.state.id === action.form.state.id; });
            if (newFormIndex < 0)
                state.registeredForms.push(action.form);
            break;
        case 'Update_Form':
            state.updateCount = state.updateCount + 1;
            break;
        case 'Remove_Form':
            var existingFormIndex = state.registeredForms.findIndex(function (it) { return it.state.id === action.id; });
            if (existingFormIndex >= 0)
                state.registeredForms = removeItemAtIndex(state.registeredForms, existingFormIndex);
            break;
    }
});
export var MetaForm = function (props) {
    var _a = __read(useReducer(metaFormReducer, {
        updateCount: 0,
        registeredForms: []
    }), 2), state = _a[0], dispatch = _a[1];
    function registerForm(form) {
        dispatch({ type: 'Register_Form', form: form });
    }
    function updateForm(id) {
        dispatch({ type: 'Update_Form' });
    }
    function removeForm(id) {
        dispatch({ type: 'Remove_Form', id: id });
    }
    // Returns all errors of forms which errored. (May return 0 if no forms errored)
    function validateAllForms() {
        return __awaiter(this, void 0, void 0, function () {
            var formErrors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(state.registeredForms.map(function (it) { return it.fullFormValidate(); }))];
                    case 1:
                        formErrors = _a.sent();
                        return [2 /*return*/, formErrors.filter(function (it) { return deepGetFirstNumberOrString(it) !== ''; })];
                }
            });
        });
    }
    function submitAllForms() {
        return __awaiter(this, void 0, void 0, function () {
            var registeredForms;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        registeredForms = state.registeredForms;
                        registeredForms.forEach(function (form) {
                            form.setErrors({});
                        });
                        return [4 /*yield*/, Promise.all(registeredForms.map(function (it) { return it.state.submitForm(); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    return (React.createElement(MetaFormContext.Provider, { value: {
            updateCount: state.updateCount,
            registeredForms: state.registeredForms,
            registerForm: registerForm,
            updateForm: updateForm,
            removeForm: removeForm,
            validateAllForms: validateAllForms,
            submitAllForms: submitAllForms,
            formSubmitting: state.registeredForms.some(function (it) { return it.state.submitting; }),
            formDirty: state.registeredForms.some(function (it) { return it.getFormIsDirty(); }),
            formInvalid: state.registeredForms.some(function (it) { return it.getFormHasErrors(); }),
            formFailedToSave: state.registeredForms.some(function (it) { return it.state.failedToSave; }),
            formErrors: state.registeredForms
                .filter(function (it) { return it.getFormHasErrors(); })
                .map(function (it) { return ({
                id: it.state.id,
                errors: it.state.errors
            }); })
        } }, props.children));
};
